import { QuestionMarkedSingle } from '@/components/features/quiz/question/question-marked';
import { QuestionBase } from '@/components/features/quiz/question/question-resolver';
import { RadioGroup } from '@/components/ui/radio-group';
import { useQuestionSingle } from '@/hooks/questions';

import type { QuestionSingleProps } from '.';

import { QuestionSingleAnswer } from '.';

export function QuestionSingle(questionSingleProps: QuestionSingleProps) {
  const { question, showMarked } = questionSingleProps;

  const { marked, answers, userAnswer, exportedUserAnswer, setAnswer, getMarkedState } = useQuestionSingle(questionSingleProps);

  return (
    <QuestionBase content={question.content} type={question.type}>
      <RadioGroup value={userAnswer?.id} onValueChange={(value) => setAnswer(value)}>
        {answers.map((answer) => (
          <QuestionSingleAnswer key={answer.id} answer={answer} showMarked={showMarked} correct={getMarkedState(answer)} />
        ))}
      </RadioGroup>
      <QuestionMarkedSingle showMarked={showMarked} marked={marked} question={question} answer={exportedUserAnswer} showQuestion={false} />
    </QuestionBase>
  );
}
